export const encodeActivity = (id: string, data?: Record<string, string>) => {
  if (!data) return id

  return `${id}/${btoa(JSON.stringify(data))}`
}
